export default __webpack_public_path__ + "static/media/icon-events-default.3864bf9a.svg";